// biome-ignore-all lint/correctness/useExhaustiveDependencies: dependências omitidas intencionalmente
import React, { useEffect, useState } from "react";

import { SelectorRow } from "Components/atoms/SelectorRow";
import { DropdownWrapper } from "./styles";
import { GuestSelectorDropdownProps } from "./types";
import InfoBubble from "../InfoBubble";

/**
 * Componente GuestSelectorDropdown
 *
 * Dropdown interativo para selecionar a quantidade de adultos, crianças e bebês.
 *
 * @param {number} adults - Quantidade de adultos selecionada.
 * @param {number} children - Quantidade de crianças selecionada.
 * @param {number} babies - Quantidade de bebês selecionada.
 * @param {object} icons - Ícones associados a cada categoria.
 * @param {(value: number) => void} onAdultsChange - Callback para alteração de adultos.
 * @param {(value: number) => void} onChildrenChange - Callback para alteração de crianças.
 * @param {(value: number) => void} onBabiesChange - Callback para alteração de bebês.
 */
export const GuestSelectorDropdown: React.FC<GuestSelectorDropdownProps> = ({
  adults,
  children,
  babies,
  icons,
  onAdultsChange,
  onChildrenChange,
  onBabiesChange,
}) => {
  const maxChildrenAndBabies = 8;

  useEffect(() => {
    if (babies > adults) {
      onBabiesChange(adults);
    }
  }, [adults, babies, children]);

  return (
    <DropdownWrapper aria-label="Guest Selector Dropdown">
      <SelectorRow
        title="Adultos"
        description="Igual ou acima de 18 anos"
        icon={icons.adults}
        value={adults}
        min={1}
        max={8}
        onIncrement={() => onAdultsChange(adults + 1)}
        onDecrement={() => onAdultsChange(adults - 1)}
      />

      <SelectorRow
        title="Crianças"
        description="Igual ou maior que 2 anos até 17 anos"
        icon={icons.children}
        value={children}
        min={0}
        max={maxChildrenAndBabies - babies}
        onIncrement={() => onChildrenChange(children + 1)}
        onDecrement={() => onChildrenChange(children - 1)}
      />
      <SelectorRow
        title="Bebês"
        description="De 0 até 23 meses"
        icon={icons.babies}
        value={babies}
        min={0}
        max={Math.min(adults, maxChildrenAndBabies - children)}
        onIncrement={() => onBabiesChange(babies + 1)}
        onDecrement={() => onBabiesChange(babies - 1)}
      />

      <InfoBubble
        title="Atenção!"
        description="Para cada bebê selecionado, também deverá conter um adulto."
      />

      {/* 
      <InfoBubble
        title="Atenção!"
        description="No momento nossa pesquisa não está funcionando para buscar passagens aéreas para Crianças e Bebês. Em breve estas opções estarão ativas novamente."
      /> */}
    </DropdownWrapper>
  );
};
